import PropTypes from 'prop-types';

import { Box, Typography } from '@mui/material';
import Switch from '@mui/material/Switch';

const CommunityOptOutComponent = (props) => {
  const { currentUserCommunities, onOptInOut } = props;

  return currentUserCommunities?.map(({ isCommunityMember, id, name }) => (
    <Box key={id} display="flex" justifyContent="space-between" gap="1rem">
      <Typography>{name}</Typography>
      <Switch
        checked={isCommunityMember}
        onChange={() => onOptInOut(id, !isCommunityMember)}
      />
    </Box>
  ));
};

CommunityOptOutComponent.propTypes = {
  currentUserCommunities: PropTypes.instanceOf(Array).isRequired,
  onOptInOut: PropTypes.func.isRequired,
};

export default CommunityOptOutComponent;
